import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import { customPartAttrsFetch, customPartAttrsUpdate, types } from './actions';

export default function* root() {
  yield takeLatest(
    types.CUSTOM_PART_ATTRS_UPDATE_REQUEST,
    watchCustomPartAttrsUpdate,
  );
}

export function* watchCustomPartAttrsFetch() {
  try {
    const groupId = yield select(getGroupId);
    const { customPartAttrs } = yield call(
      API.supplier.getCustomPartAttrs,
      groupId,
    );
    yield put(customPartAttrsFetch.success({ customPartAttrs }));
  } catch (error) {
    console.error('ERROR FETCHING CUSTOM PART ATTRS', error);
  }
}

export function* watchCustomPartAttrsUpdate(action) {
  const { customPartAttrs } = action.payload;
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(API.supplier.updateCustomPartAttrs, groupId, {
      customPartAttrs,
    });
    yield put(
      customPartAttrsUpdate.success({
        customPartAttrs: response.customPartAttrs,
      }),
    );
  } catch (e) {
    yield put(customPartAttrsUpdate.error(e));
  }
}

export function* initSaga() {
  yield call(watchCustomPartAttrsFetch);
}
